import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const SkuApi = createApi({
  reducerPath: "Sku",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND2_URL}/v1/skus`,
    credentials: "include",
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getAllSkus: builder.query({
      query: () => `?limit=1000`,
    }),
    getSkuDropdown: builder.query({
      query: () => `?page=1&limit=100000`,
    }),
  }),
});

export const { useGetAllSkusQuery, useGetSkuDropdownQuery } = SkuApi;
